import React, { FC } from "react";
import "./Input.scss";
import CrossIcon from "assets/icons/crossAccent.svg";
import LoopIcon from "assets/icons/loop.svg";
import SearchIcon from "assets/icons/courses/search.svg";

interface Props
  extends React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  label?: string;
  showClearButton?: boolean;
  onClear?: () => void;
  showSearchIcon?: boolean;
  isMobile?: boolean;
}

const Input: FC<Props> = ({
  label,
  showClearButton,
  onClear,
  showSearchIcon,
  isMobile,
  ...restProps
}) => {
  return (
    <div className="Input-otr">
      {label && <label className="label-input-otr">{label}</label>}

      {showClearButton && onClear && (
        <div className="input-icon-container-left" onClick={onClear}>
          <img src={CrossIcon} alt="Clear" className="input-icon" />
        </div>
      )}

      <input className="Input-theme" type="text" name="text" {...restProps} />

      {showSearchIcon && (
        <div className="input-icon-container-right">
          <img src={isMobile ? SearchIcon : LoopIcon} alt="Search" />
        </div>
      )}
    </div>
  );
};

export default Input;
